/** Mise en forme des indicateurs de la plateforme (espace /superadmin). */

export const SERIES_COLOR = '#00a54f';

export function formatMoney(value: number): string {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);
}

export function formatPercent(ratio: number | null): string {
  return ratio === null ? '—' : `${Math.round(ratio * 100)} %`;
}

/** « 2026-10 » → « oct. 26 » (axe des graphiques). */
export function shortMonth(month: string): string {
  const [year, monthIndex] = month.split('-').map(Number) as [number, number];
  return new Date(Date.UTC(year, monthIndex - 1, 1)).toLocaleDateString('fr-FR', { month: 'short', year: '2-digit', timeZone: 'UTC' });
}

/** Variation du dernier mois complet par rapport au précédent, pour le sous-titre d'une carte. */
export function monthOverMonth(values: number[]): string | null {
  if (values.length < 3) return null;
  // Le dernier élément est le mois en cours (partiel) : on compare les deux derniers mois complets.
  const previous = values[values.length - 3]!;
  const last = values[values.length - 2]!;
  if (previous === 0) return last === 0 ? 'stable sur le dernier mois complet' : `${last} le mois dernier (aucun avant)`;
  const change = Math.round(((last - previous) / previous) * 100);
  return `${change > 0 ? '+' : ''}${change} % le mois dernier`;
}
